import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { LIBRARY_FILTER } from 'Pods/ThreeDStudio/Store/constants'

import FilteringCheckbox from './Components/FilteringCheckbox/FilteringCheckbox'
import GeneratedSubItems from './Components/GeneratedSubItems/GeneratedSubItems'

function FilteringContent() {
  const t = useTranslation()

  return (
    <div className="filtering-content">
      <FilteringCheckbox
        keyName="generated"
        id="filtering-content-generated"
        label={t('sidebar.filtering.generated')}
      />
      <GeneratedSubItems />
      <FilteringCheckbox
        keyName={LIBRARY_FILTER.PURCHASED}
        id="filtering-content-purchased"
        label={t('sidebar.filtering.purchased')}
      />
      <FilteringCheckbox
        keyName={LIBRARY_FILTER.UPLOADED}
        id="filtering-content-uploaded"
        label={t('sidebar.filtering.uploaded')}
      />
    </div>
  )
}

export default memo(FilteringContent)
